<script lang="ts">
  import { userbaseStore, LogStore } from "../../stores/stores";
  import type { LogEntry } from "../../stores/types";

  export let logentry;

  let logPromise = null;
  let logData: LogEntry = logentry.item;

  const handleDelete = () => {
    if (confirm("really delete this item?:   " + logentry.itemId)) {
      logPromise = $userbaseStore.deleteItem({
        databaseName: "logs",
        itemId: logentry.itemId,
      });
    }
  };
</script>

<div class="logentry">
  timestamp: {logentry.createdBy.timestamp} <br />
  action: {logentry.item.action}
  <div class="delete-item" title="Delete item">
    <span class="icon-button"
      ><i class="fas fa-trash-alt" on:click={() => handleDelete()} /></span
    >
  </div>
</div>
